
  import moment from 'moment'
  import { defineComponent, reactive, onMounted } from 'vue'
  import { queryApplyInfo, wechatLogin } from '@/apis/comm/api'
  import { useRouter } from 'vue-router'
  import { useRoute } from 'vue-router'
  import { showSuccessToast, showToast, showLoadingToast } from 'vant'
  import '../../assets/css/ub.css'
  import axios from '@/apis/config'
  import _ from 'lodash'

  export default defineComponent({
    setup() {
      const route = useRoute()
      const router = useRouter()

      onMounted(async () => {
        dataState.shdate = moment().format('YYYY-MM-DD')
        const query = route.query
        if (query && query.id) {
          dataState.id = query.id
          if (query.token) dataState.token = query.token
          if (query.uid) {
            const { data } = await wechatLogin({ uid: query.uid })
            dataState.token = data.data['Authorization']
          }
          dataState.sdWorkHandleId = query.sdWorkHandleId
          dataState.getApplyInfo()
          dataState.getApprovalBase()
        }
        if (query && query.view) {
          dataState.view = true
          dataState.getApprovalInfo()
        }
        dataState.resetPc()
      })
      const dataState = reactive({
        id: '' as any,
        token: '' as any,
        sdWorkHandleId: '' as any,
        view: false,
        form: {},
        idea: undefined as any,
        shr: '',
        shdate: '',
        search_loading: false,
        applyInfo: {} as any,
        dataList: [],
        remark: '',
        url: (window as any).VUE_APP_BASE_URL,
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            customRender: ({ text, record, index }) => {
              return index + 1
            }
          },
          {
            title: '车牌号',
            dataIndex: 'plateNum',
            key: 'plateNum'
          },
          {
            title: '车主姓名',
            dataIndex: 'visitorName',
            key: 'visitorName'
          },
          {
            title: '联系电话',
            dataIndex: 'visitorPhone',
            key: 'visitorPhone'
          }
        ],

        resetPc() {
          var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
          var bodyWidth = document.body.clientWidth // 当前窗口的宽度
          var rem = bodyWidth * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
          document.getElementsByTagName('html')[0].style.fontSize = rem + 'px'
        },
        async getApplyInfo() {
          const { data } = await queryApplyInfo(dataState.id)
          if (data.code == 200) {
            data.data.visiStartTime = data.data.visiStartTime.slice(0, 10)
            dataState.applyInfo = data.data
            dataState.dataList = data.data.carsRecordList
            dataState.view = data.data.approvalState == '5' ? false : true
          }
        },
        async getApprovalBase() {
          axios
            .get(dataState.url + '/spWorkHandle/getSpWorkHandleById/' + dataState.sdWorkHandleId, {
              headers: {
                Authorization: dataState.token
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                dataState.form = res.data.data
                dataState.shr = res.data.data.handler
              }
            })
        },
        async getApprovalInfo() {
          axios
            .get(dataState.url + '/sdApprovalInfo/selectCaApprovalInfoByProWorkHandelId/' + dataState.sdWorkHandleId, {
              headers: {
                Authorization: dataState.token
              }
            })
            .then(res => {
              if (res.data.code == 200 && res.data.data) {
                dataState.remark = res.data.data.approvalOpinion
                dataState.shdate = res.data.data.approvalTime.slice(0, 10)
                dataState.idea = res.data.data.idea
                dataState.shr = res.data.data.approvalName
              }
            })
        },

        async submit(val: any) {
          let data = {
            approvalOpinion: dataState.remark, //意见
            idea: val
          }
          if (val == 2 && !data.approvalOpinion) {
            data.approvalOpinion = '不同意'
          }
          if (val == 1 && !data.approvalOpinion) {
            data.approvalOpinion = '同意'
          }
          const loading = showLoadingToast({
            message: '提交中...',
            forbidClick: true
          })
          let query = _.assign(data, dataState.form)
          axios
            .post(dataState.url + '/task/formDataSave', query, {
              headers: {
                Authorization: dataState.token
              }
            })
            .then(res => {
              loading.close()
              if (res.data.code == 200) {
                showSuccessToast('审批成功')
                dataState.view = true
                window.close()
              } else {
                showToast(res.data.msg)
              }
            })
        }
      })

      return {
        dataState
      }
    }
  })
